import React from 'react';
import { Sun, Sparkles, Palette, Layers, Wand2, Coffee } from 'lucide-react';

const BalayageStyles = () => {
  const styles = [
    {
      icon: Sun,
      name: 'California Balayage',
      keyword: 'california balayage vancouver',
      description:
        "Beachy, sun-bleached blonde inspired by Malibu summers. Painted heavier through the mid-lengths and ends for a lit-from-within glow. Perfect for Vancouver clients who want that West Coast surfer-girl warmth without harsh contrast.",
    },
    {
      icon: Sparkles,
      name: 'Blonde Balayage',
      keyword: 'blonde balayage vancouver',
      description:
        'From icy platinum to buttery honey — hand-painted blonde balayage tailored to your skin tone and base. Includes toning for the perfect cool, neutral, or warm finish. Our most-requested service in Downtown Vancouver.',
    },
    {
      icon: Coffee,
      name: 'Brunette Balayage',
      keyword: 'brunette balayage vancouver',
      description:
        "Chocolate, caramel, mocha, and toffee dimensions painted through natural brunette bases. Adds depth and light without heavy commitment — ideal for dark-haired Vancouverites who want subtle luxury.",
    },
    {
      icon: Wand2,
      name: 'Money Piece & Face Framing',
      keyword: 'money piece vancouver',
      description:
        'Brightening face-framing pieces that instantly lift the complexion. Painted around the hairline for a modern, editorial finish. Popular as an add-on or standalone service in Downtown Vancouver.',
    },
    {
      icon: Layers,
      name: 'Lived-In Balayage',
      keyword: 'lived-in balayage vancouver',
      description:
        'Soft, low-maintenance blend designed to grow out beautifully over 4–6 months. Perfect for busy West End, Yaletown, and Kitsilano clients who want colour that always looks intentional — never rooty.',
    },
    {
      icon: Palette,
      name: 'Root Smudge & Shadow Root',
      keyword: 'shadow root vancouver',
      description:
        'Seamless root melt that softens the transition between natural regrowth and painted highlights. Extends the life of your balayage and cuts salon visits in half. Included with most full balayage services.',
    },
  ];

  return (
    <section
      id="balayage-styles"
      data-testid="balayage-styles-section"
      className="section-padding bg-gradient-to-b from-black via-[#0f0f0f] to-black relative overflow-hidden"
    >
      <div className="absolute top-1/3 right-0 w-[500px] h-[500px] bg-[#c9a961]/6 rounded-full blur-[140px]"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-[#c9a961] text-sm font-semibold tracking-[0.2em] uppercase">
              Balayage Styles
            </span>
          </div>
          <h2 className="font-['Playfair_Display'] text-5xl md:text-6xl font-light text-[#f8f6f0] mb-6">
            Balayage Styles We Specialize In
            <span className="block text-[#c9a961] text-3xl md:text-4xl mt-4">
              — For Every Vancouver Look
            </span>
          </h2>
          <p className="text-[#f8f6f0]/70 text-lg max-w-3xl mx-auto leading-relaxed">
            Whether you're after California balayage, blonde balayage, brunette dimension, or a
            subtle money piece, our Downtown Vancouver colour specialists custom-paint every look
            to your hair, skin tone, and lifestyle. Explore the balayage styles most requested at
            Prép Beauty Parlour.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {styles.map((style, index) => (
            <article
              key={index}
              data-testid={`balayage-style-${index}`}
              className="group p-8 bg-gradient-to-br from-[#1a1a1a] to-black border border-[#c9a961]/20 hover:border-[#c9a961]/50 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_0_40px_rgba(201,169,97,0.2)]"
            >
              <div className="w-14 h-14 rounded-full bg-[#c9a961]/10 flex items-center justify-center mb-6 group-hover:bg-[#c9a961]/20 transition-colors duration-300">
                <style.icon className="text-[#c9a961]" size={26} />
              </div>
              <h3 className="font-['Playfair_Display'] text-2xl text-[#f8f6f0] mb-3">
                {style.name}
              </h3>
              <p className="text-[#f8f6f0]/70 text-sm leading-relaxed">{style.description}</p>
            </article>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#c9a961]/10 via-transparent to-[#c9a961]/10 border-y border-[#c9a961]/20 py-8 px-6 text-center">
          <p className="text-[#f8f6f0]/80 text-base md:text-lg leading-relaxed max-w-4xl mx-auto">
            Serving <span className="text-[#c9a961]">Downtown Vancouver</span>,{' '}
            <span className="text-[#c9a961]">West End</span>,{' '}
            <span className="text-[#c9a961]">Yaletown</span>,{' '}
            <span className="text-[#c9a961]">Davie Village</span>,{' '}
            <span className="text-[#c9a961]">Kitsilano</span>,{' '}
            <span className="text-[#c9a961]">Coal Harbour</span>,{' '}
            <span className="text-[#c9a961]">Fairview</span>, and{' '}
            <span className="text-[#c9a961]">Gastown</span> — Vancouver's balayage specialists at
            1305 Burrard Street.
          </p>
        </div>
      </div>
    </section>
  );
};

export default BalayageStyles;
